/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Only provided for WebhookType==UptimeReport
 * @export
 * @interface UptimeReportMetadata
 */
export interface UptimeReportMetadata {
    /**
     * Report period
     * @type {string}
     * @memberof UptimeReportMetadata
     */
    period?: UptimeReportMetadataPeriodEnum;
}

/**
 * @export
 */
export const UptimeReportMetadataPeriodEnum = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;
export type UptimeReportMetadataPeriodEnum =
    (typeof UptimeReportMetadataPeriodEnum)[keyof typeof UptimeReportMetadataPeriodEnum];

/**
 * Check if a given object implements the UptimeReportMetadata interface.
 */
export function instanceOfUptimeReportMetadata(
    value: object,
): value is UptimeReportMetadata {
    return true;
}

export function UptimeReportMetadataFromJSON(json: any): UptimeReportMetadata {
    return UptimeReportMetadataFromJSONTyped(json, false);
}

export function UptimeReportMetadataFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UptimeReportMetadata {
    if (json == null) {
        return json;
    }
    return {
        period: json["period"] == null ? undefined : json["period"],
    };
}

export function UptimeReportMetadataToJSON(
    value?: UptimeReportMetadata | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        period: value["period"],
    };
}
